import { VERIFICATION_STATE } from '../../constants';
import {
  SET_PREPROCESS_RUNNING,
  SET_VERIFICATION,
  SET_VERIFICATION_LABELS,
  SET_VERIFICATION_PROGRESS,
  SET_VERIFICATION_STATE
} from '../actions/verification';

const defaultState = {
  state: VERIFICATION_STATE.IN_PROGRESS,
  result: null,
  preprocessRunning: true,
  progress: 0,
  labels: {
    footer: '',
    header: '',
    headerHighlight: '',
    progressing: ''
  },
  errors: []
};

export default function(state = defaultState, action) {
  switch (action.type) {
  case SET_PREPROCESS_RUNNING:
    return { ...state, preprocessRunning: action.preprocessRunning };
  case SET_VERIFICATION:
    return { ...state, ...action.verification };
  case SET_VERIFICATION_LABELS: {
    const labels = {
      footer: '',
      header: '',
      headerHighlight: '',
      progressing: '',
      ...action.labels
    };
    return { ...state, labels, progress: 0 };
  }
  case SET_VERIFICATION_PROGRESS:
    return { ...state, progress: action.progress };
  case SET_VERIFICATION_STATE:
    return { ...state, state: action.state };
  default:
    return state;
  }
}
